import React from "react";

const InputText1 = ({ title, placeholder, name, value, onChange, readonly=false,type='text', onClick,maxLength=50, onBlur=null}) => {
  return (
    <div className="d-flex flex-column mb-3 px-4">
      <p className="semibold ">{title}</p>
      <input
        className="r form-control"
        type={type}
        placeholder={placeholder}
        name={name}
        value={value}
        onChange={onChange}
        readOnly={readonly ? "readonly" : ""}
        onClick={onClick}
        maxLength={maxLength}
        onBlur={onBlur}
      />
    </div>
  );
};

export default InputText1;
